import { gql } from "@apollo/client";
import { useState, useEffect } from "react";

// Components
import Head from "next/head";
import Script from "next/script";
import Header from "@/components-layout/header/header";
import Footer from "@/components-layout/footer/footer";
import Container from "@/components-layout/container/container";
import Searchbar from "@/components/searchbar/searchbar";
import AbaIcon from "@/components/aba-icon/aba-icon";
import IngredientForm from "@/components/ingredientForm/ingredient-form";
import Image from "next/image";
import bgImg from "../public/dots-bg@3x.jpg";

// Style
import style from "@/styles/front-page.module.scss";

// Constants
import { genSetVars, imgFields } from "@/constants/gql-fields";

const Background = () => {
  return (
    <div className={style.background}>
      {/* <img
        className={style.backgroundD}
        src="/dots-bg@3x.jpg"
        alt=""
        fetchPriority="high"
      /> */}
      <Image
        className={style.backgroundD}
        // src="/dots-bg@3x.jpg"
        src={bgImg}
        alt=""
        priority
      />
    </div>
  );
};

export default function Component(props) {
  // Loading state for previews
  if (props.loading) {
    return <>Loading...</>;
  }
  // Variables
  const data = props.data;
  // const siteTitle = data.generalSettings.title;
  const homeCopy = data.page.pageHome;
  const pageTitle =
    homeCopy.pageTitle ??
    "Want to know more about the ingredients in your drink?";
  const col1Text = homeCopy.col1Text ?? "";
  const col2Text = homeCopy.col2Text ?? "";
  const col3Text = homeCopy.col3Text ?? "";
  const hasSubhead = col1Text || col2Text || col3Text;
  // const { title, id, content, modules } = data.page;

  const [showMobile, setShowMobile] = useState(false);
  useEffect(() => {
    const mobileNav = document.getElementById("mobileNav");

    if (mobileNav) {
      mobileNav.addEventListener("click", (e) => {
        const btn = e.currentTarget;
        setShowMobile(btn.getAttribute("state") == "closed" ? true : false);
      });
    }
  }, [showMobile]);

  return (
    <>
      <Head>
        {/* <title>{`Front Page - ${siteTitle}`}</title> */}
        <title>{data.page.seo.title}</title>
        <meta name="description" content={data.page.seo.metaDesc} />
        <Script async src="https://www.google.com/recaptcha/api.js" />
      </Head>

      <Header entry={data.generalSettingsOptionsPage.generalSettingsACF} />

      <main>
        {/* <div className={style.bgIcons}>
          <AbaIcon name={AbaIcon.LIST.globe} id="globe" />
          <AbaIcon name={AbaIcon.LIST.iCircle} id="circle" />
          <AbaIcon name={AbaIcon.LIST.soda} id="soda" />
          <AbaIcon name={AbaIcon.LIST.sodaBottle} id="bottle" />
        </div> */}
        <Background />
        <section className={style.section}>
          <Container className={style.container}>
            <h1 className={style.title}>{pageTitle}</h1>
            {hasSubhead && (
              <div className={style.subhead}>
                <div className={style.subheadItem}>
                  <AbaIcon name={AbaIcon.LIST.star} />
                  <p>{col1Text}</p>
                </div>
                <div className={style.subheadItem}>
                  <AbaIcon name={AbaIcon.LIST.doubleArrow} />
                  <p>{col2Text}</p>
                </div>
                <div className={style.subheadItem}>
                  <AbaIcon name={AbaIcon.LIST.checkmark} />
                  <p>{col3Text}</p>
                </div>
              </div>
            )}

            {homeCopy.missionStatement && (
              <div className={style.missionStatement}>
                {homeCopy.missionStatementTitleOrImage === "title" && (
                  <h2>{homeCopy.missionStatementTitle}</h2>
                )}
                {homeCopy.missionStatementTitleOrImage === "image" && (
                  <Image
                    src={homeCopy.missionStatementImage.node.sourceUrl}
                    alt={homeCopy.missionStatementImage.node.altText}
                    width={175}
                    height={115}
                    priority={true}
                  />
                )}
                <div
                  dangerouslySetInnerHTML={{
                    __html: homeCopy.missionStatement,
                  }}
                />
              </div>
            )}

            {!showMobile && (
              <div className={style.searchWrapper}>
                <Searchbar />
              </div>
            )}
          </Container>
        </section>

        {data.page?.pageIngredientForm && (
          <IngredientForm data={data.page?.pageIngredientForm} />
        )}
      </main>

      <Footer entry={data.generalSettingsOptionsPage.generalSettingsACF} />
    </>
  );
}

Component.query = gql`
  query GetHomePage($databaseId: ID! = 1008) {
    # -- Site Settings
    # generalSettings {
    #   title
    # }

    page(id: $databaseId, idType: DATABASE_ID) {
      pageHome {
        __typename
        pageTitle
        missionStatementTitleOrImage
        missionStatementTitle
        missionStatementImage {
          ${imgFields}
        }
        missionStatement
      }
      pageIngredientForm {
        id
        __typename
        ...IngredientFormFragment
      }
      seo {
        metaDesc
        # fullHead
        title
      }
    }

    # Gravity Forms
    ...GFormFragment

    ...HeaderFragment @unmask(mode: "migrate")
    ...FooterFragment @unmask(mode: "migrate")
    
    # -- General Settings Variables
    ${genSetVars}
  }
  ${Header.fragments.entry}
  ${Footer.fragments.entry}
  ${IngredientForm.fragments.gforms}
  ${IngredientForm.fragments.copy}
`;
